import type { Translations } from './en.js';

const ko: Translations = {
  // === Common UI ===
  ok: '확인',
  cancel: '취소',
  close: '닫기',
  confirm: '확인',
  retry: '다시 시도',
  back: '뒤로',
  settings: '설정',
  language: '언어',

  // === Game Common ===
  score: '점수',
  level: '레벨',
  game_over: '게임 오버',
  restart: '다시 시작',
  pause: '일시정지',
  resume: '계속',

  // === Settings ===
  settings_sound: '사운드',
  settings_music: '음악',
  settings_reset: '게임 초기화',
  settings_reset_confirm: '모든 진행 상황을 초기화할까요?',

  // === Ads ===
  ad_watch: '광고 보기',
  ad_reward: '무료 보상',
  ad_loading: '광고 로딩 중...',
  ad_reward_received: '보상을 받았습니다!',
  ad_not_completed: '광고를 완료하지 못했습니다',

  // === Offline ===
  offline_title: '돌아오셨군요!',
  offline_earned: '부재 중 획득',

  // === Game HUD ===
  sp: 'SP',
  fame: '명성',
  building_tab: '건물',
  ghosts_tab: '유령',
  shop_tab: '상점',
  prestige_tab: '프레스티지',

  // === New tabs ===
  training_tab: '훈련',
  facilities_tab: '부대시설',
  reviews_tab: '리뷰',

  // === Building ===
  floor_label: '{n}층',
  buy_floor: '층 구매',
  buy_floor_cost: '층 구매 ({sp} SP)',
  unlock_slot: '슬롯 해금',
  unlock_slot_cost: '슬롯 해금 ({sp} SP)',
  build_room: '방 건설',
  upgrade_room: '방 업그레이드',
  upgrade_room_cost: '업그레이드 ({sp} SP)',
  room_empty: '비어있음',
  room_locked: '잠김',
  no_ghost: '유령 없음',
  assign_ghost: '유령 배치',
  visitors_floor: '이 층의 방문객',
  add_floor: '층 추가',
  add_floor_cost: '+ 새 층 ({sp} SP)',

  // === New tabs ===
  menu_tab: '메뉴',

  // === Room Types ===
  room_dark_corridor: '어둠의 복도',
  room_dark_corridor_desc: '심리 공포 +30%',
  room_mirror_room: '거울 방',
  room_mirror_room_desc: '시각 +25%, 심리 +15%',
  room_dungeon: '지하 감옥',
  room_dungeon_desc: '심리 +20%, 물리 +20%',
  room_graveyard: '묘지 방',
  room_graveyard_desc: '심리 공포 +40%',
  room_lab: '실험실',
  room_lab_desc: '시각 +30%, 물리 +20%',
  room_library: '도서관',
  room_library_desc: '심리 +35%, 청각 +15%',
  room_coffin_room: '관 방',
  room_coffin_room_desc: '시각 +30%, 심리 +20%',
  room_doll_room: '인형 방',
  room_doll_room_desc: '시각 +20%, 심리 +35%',
  room_kitchen: '저주받은 주방',
  room_kitchen_desc: '물리 +30%, 청각 +20%',
  room_bathroom: '유령 화장실',
  room_bathroom_desc: '심리 +30%, 청각 +25%',

  // === 새로운 방 ===
  room_funhouse: '거울 미로',
  room_funhouse_desc: '시각 +35%, 심리 +20%',
  room_trapeze_room: '공중그네 방',
  room_trapeze_room_desc: '물리 +30%, 시각 +15%',
  room_freak_show: '기형 쇼',
  room_freak_show_desc: '시각 +40%, 심리 +30%',
  room_sacrifice_altar: '제단',
  room_sacrifice_altar_desc: '심리 +40%, 시각 +20%',
  room_treasure_vault: '보물 금고',
  room_treasure_vault_desc: '심리 +20%, 청각 +20%',
  room_underground_river: '지하 강',
  room_underground_river_desc: '청각 +30%, 심리 +20%',
  room_curse_chamber: '저주의 방',
  room_curse_chamber_desc: '심리 +45%, 물리 +15%',
  room_mummy_tomb: '미라 무덤',
  room_mummy_tomb_desc: '시각 +30%, 심리 +30%',
  room_captain_cabin: '선장실',
  room_captain_cabin_desc: '심리 +30%, 시각 +20%',
  room_cargo_hold: '화물칸',
  room_cargo_hold_desc: '물리 +25%, 청각 +20%',
  room_davy_jones_locker: '데이비 존스의 금고',
  room_davy_jones_locker_desc: '심리 +35%, 시각 +25%',
  room_brig: '감옥칸',
  room_brig_desc: '물리 +30%, 심리 +20%',
  room_crows_nest: '까마귀 둥지',
  room_crows_nest_desc: '물리 +35%, 시각 +20%',
  room_mine_shaft: '광산 갱도',
  room_mine_shaft_desc: '물리 +30%, 청각 +20%',
  room_crystal_cave: '수정 동굴',
  room_crystal_cave_desc: '시각 +35%, 청각 +15%',
  room_explosives_storage: '폭약 저장실',
  room_explosives_storage_desc: '물리 +40%, 청각 +25%',
  room_underground_lake: '지하 호수',
  room_underground_lake_desc: '심리 +30%, 청각 +25%',
  room_rail_tunnel: '광산 레일 터널',
  room_rail_tunnel_desc: '물리 +30%, 심리 +20%',
  room_throne_room: '왕좌의 방',
  room_throne_room_desc: '시각 +25%, 심리 +30%',
  room_wine_cellar: '와인 저장고',
  room_wine_cellar_desc: '심리 +30%, 시각 +15%',
  room_tower_chamber: '탑 방',
  room_tower_chamber_desc: '심리 +35%, 물리 +20%',
  room_server_room: '서버실',
  room_server_room_desc: '청각 +30%, 시각 +20%',
  room_quarantine_zone: '격리 구역',
  room_quarantine_zone_desc: '심리 +35%, 물리 +20%',
  room_armory: '무기고',
  room_armory_desc: '물리 +35%, 시각 +20%',
  room_witch_hut: '마녀의 오두막',
  room_witch_hut_desc: '시각 +30%, 심리 +25%',
  room_treehouse: '나무집',
  room_treehouse_desc: '물리 +25%, 청각 +20%',
  room_swamp_path: '늪지길',
  room_swamp_path_desc: '심리 +30%, 청각 +20%',
  room_fairy_ring: '요정의 원환',
  room_fairy_ring_desc: '심리 +40%, 시각 +20%',
  room_ancient_ruin: '고대 유적',
  room_ancient_ruin_desc: '심리 +35%, 시각 +25%',
  room_attic: '다락방',
  room_attic_desc: '심리 +30%, 청각 +15%',
  room_secret_passage: '비밀 통로',
  room_secret_passage_desc: '심리 +35%, 물리 +15%',
  room_morgue: '영안실',
  room_morgue_desc: '시각 +30%, 심리 +30%',
  room_surgery_room: '수술실',
  room_surgery_room_desc: '물리 +35%, 시각 +25%',
  room_music_room: '음악실',
  room_music_room_desc: '청각 +40%, 심리 +20%',
  room_science_lab: '과학 실험실',
  room_science_lab_desc: '시각 +30%, 물리 +25%',

  // Cursed Circus new
  room_ticket_booth: '매표소',
  room_ticket_booth_desc: '심리 +25%, 시각 +20%',
  room_animal_cage: '동물 우리',
  room_animal_cage_desc: '물리 +30%, 시각 +25%',
  room_clown_tent: '광대 텐트',
  room_clown_tent_desc: '심리 +40%, 시각 +20%',
  room_hall_of_mirrors: '거울의 방',
  room_hall_of_mirrors_desc: '시각 +40%, 심리 +30%',
  // Abandoned Mine new
  room_elevator_shaft: '승강기 통로',
  room_elevator_shaft_desc: '물리 +35%, 심리 +20%',
  room_ore_processing: '광석 처리장',
  room_ore_processing_desc: '청각 +30%, 물리 +20%',
  room_collapsed_tunnel: '붕괴된 갱도',
  room_collapsed_tunnel_desc: '물리 +40%, 심리 +25%',
  room_miners_quarters: '광부 숙소',
  room_miners_quarters_desc: '심리 +30%, 시각 +20%',
  // Underground Bunker new
  room_command_center: '지휘 통제실',
  room_command_center_desc: '심리 +30%, 청각 +25%',
  room_ventilation_shaft: '환기 덕트',
  room_ventilation_shaft_desc: '물리 +35%, 청각 +25%',
  room_decontamination: '오염 제거실',
  room_decontamination_desc: '심리 +35%, 시각 +25%',
  // Cursed Forest new
  room_hollow_tree: '속이 빈 고목',
  room_hollow_tree_desc: '시각 +30%, 심리 +25%',
  room_spider_nest: '거미 둥지',
  room_spider_nest_desc: '시각 +35%, 물리 +25%',
  room_moonlit_clearing: '달빛 공터',
  room_moonlit_clearing_desc: '심리 +40%, 청각 +20%',
  room_abandoned_cabin: '버려진 오두막',
  room_abandoned_cabin_desc: '심리 +30%, 시각 +20%',

  // New: Abandoned Hospital
  room_ward_room: '병실',
  room_ward_room_desc: '심리 +30%, 시각 +20%',
  room_reception_hall: '접수실',
  room_reception_hall_desc: '심리 +25%, 청각 +20%',
  room_x_ray_room: 'X-ray 촬영실',
  room_x_ray_room_desc: '시각 +35%, 물리 +20%',

  // New: School Back Mountain
  room_classroom: '교실',
  room_classroom_desc: '심리 +30%, 청각 +15%',
  room_art_room: '미술실',
  room_art_room_desc: '시각 +35%, 심리 +20%',
  room_gymnasium: '체육관',
  room_gymnasium_desc: '물리 +30%, 청각 +25%',
  room_rooftop: '옥상',
  room_rooftop_desc: '심리 +40%, 물리 +20%',

  // New: Ancient Temple
  room_crypt: '지하 납골당',
  room_crypt_desc: '시각 +35%, 심리 +25%',

  // New: Pirate Ship
  room_powder_room: '화약고',
  room_powder_room_desc: '물리 +40%, 청각 +20%',
  room_navigation_room: '항해실',
  room_navigation_room_desc: '심리 +30%, 시각 +20%',

  // New: Gothic Castle
  room_banquet_hall: '연회장',
  room_banquet_hall_desc: '심리 +30%, 시각 +20%',
  room_chapel: '예배당',
  room_chapel_desc: '심리 +40%, 청각 +20%',
  room_torture_chamber: '고문실',
  room_torture_chamber_desc: '물리 +40%, 시각 +30%',

  // New: Underground Bunker
  room_armory_hall: '무기 전시실',
  room_armory_hall_desc: '물리 +30%, 시각 +25%',
  room_science_room: '연구실',
  room_science_room_desc: '시각 +30%, 심리 +20%',

  // === 해금 조건 ===
  unlock_requires_day: '{n}일차 이상',
  unlock_requires_fame: '명성 {n}+',
  unlock_requires_room: '선행: {name}',
  unlock_condition_not_met: '조건 미충족',

  // === 시너지 이름 ===
  synergy_active_count: '시너지 {n} 활성',
  synergy_popup_title: '활성 시너지',
  syn_fx_dark_mirror_e1: '거울의 환영',
  syn_fx_dark_mirror_e2: '분신의 저주',
  syn_fx_underground_horror_e1: '지하 감옥의 비명',
  syn_fx_underground_horror_e2: '죽음의 메아리',
  syn_fx_restless_spirits_e1: '망자의 한숨',
  syn_fx_restless_spirits_e2: '유령의 행렬',
  syn_fx_creepy_collection_e1: '인형의 저주',
  syn_fx_creepy_collection_e2: '거울 속 미로',
  syn_fx_mad_scientist_e1: '광기의 실험',
  syn_fx_mad_scientist_e2: '연금술의 보상',
  syn_fx_hidden_paths_e1: '그림자의 미로',
  syn_fx_hidden_paths_e2: '숨겨진 공포',
  syn_fx_circus_nightmare_e1: '광대의 유희',
  syn_fx_circus_nightmare_e2: '서커스의 악몽',
  syn_fx_ancient_curse_e1: '고대의 저주',
  syn_fx_ancient_curse_e2: '미라의 분노',
  syn_fx_hidden_treasures_e1: '보물의 유혹',
  syn_fx_hidden_treasures_e2: '지하의 발견',
  syn_fx_ship_of_doom_e1: '바다의 장송곡',
  syn_fx_ship_of_doom_e2: '데이비 존스의 징벌',
  syn_fx_prison_horror_e1: '감옥의 탈출',
  syn_fx_prison_horror_e2: '사슬의 속박',
  syn_fx_deep_descent_e1: '수정의 빛',
  syn_fx_deep_descent_e2: '지하의 신비',
  syn_fx_boom_scare_e1: '폭발의 여파',
  syn_fx_boom_scare_e2: '연쇄 폭발',
  syn_fx_royal_terror_e1: '왕의 분노',
  syn_fx_royal_terror_e2: '왕실의 보물',
  syn_fx_noble_cellar_e1: '와인의 향기',
  syn_fx_noble_cellar_e2: '비밀 저장고',
  syn_fx_quarantine_protocol_e1: '격리 경보',
  syn_fx_quarantine_protocol_e2: '생물학적 위협',
  syn_fx_nature_wrath_e1: '마녀의 안개',
  syn_fx_nature_wrath_e2: '대지의 분노',
  syn_fx_ancient_power_e1: '고대의 힘',
  syn_fx_ancient_power_e2: '신비한 유적',
  syn_fx_echo_chamber_e1: '메아리의 저주',
  syn_fx_echo_chamber_e2: '음악의 환영',
  syn_fx_water_horror_e1: '심연의 공포',
  syn_fx_water_horror_e2: '물의 속삭임',
  syn_fx_full_course_e1: '풀코스 향연',
  syn_fx_full_course_e2: '만족의 미소',
  synergy_dark_mirror: '다크 미러',
  synergy_dark_mirror_desc: '어두운 복도 + 거울 방: 분위기 +15%, 공포 +10%',
  synergy_underground_horror: '지하 공포',
  synergy_underground_horror_desc: '던전/관방 조합: 공포 +20%, 위협 +10%',
  synergy_restless_spirits: '불안한 영혼',
  synergy_restless_spirits_desc: '묘지/관방/영안실: 분위기 +20%, 방문객 +10%',
  synergy_creepy_collection: '소름 컬렉션',
  synergy_creepy_collection_desc: '인형/거울/펀하우스: 공포 +15%, 스릴 +10%',
  synergy_mad_scientist: '매드 사이언티스트',
  synergy_mad_scientist_desc: '실험실/수술실/과학: 스릴 +20%, SP +15%',
  synergy_hidden_paths: '숨겨진 길',
  synergy_hidden_paths_desc: '비밀통로/복도/다락방: 분위기 +15%, 연쇄 +20%',
  synergy_circus_nightmare: '서커스 악몽',
  synergy_circus_nightmare_desc: '펀하우스/프릭쇼/트래피즈: 재미 +20%, 공포 +15%',
  synergy_ancient_curse: '고대의 저주',
  synergy_ancient_curse_desc: '제단/저주방/미라묘: 공포 +25%, 위협 +15%',
  synergy_hidden_treasures: '숨겨진 보물',
  synergy_hidden_treasures_desc: '보물금고 + 지하강: SP +20%, 방문객 +10%',
  synergy_ship_of_doom: '파멸의 호',
  synergy_ship_of_doom_desc: '선장실/화물칸/데이비: 분위기 +15%, 공포 +15%',
  synergy_prison_horror: '감옥 공포',
  synergy_prison_horror_desc: '감금실 + 데이비: 스릴 +20%, 위협 +10%',
  synergy_deep_descent: '심연 강하',
  synergy_deep_descent_desc: '광산/수정동굴/지하호수: 분위기 +20%, 방문객 +15%',
  synergy_boom_scare: '폭발 공포',
  synergy_boom_scare_desc: '폭약실 + 레일터널: 스릴 +25%, 연쇄 +15%',
  synergy_royal_terror: '왕좌의 공포',
  synergy_royal_terror_desc: '왕좌/탑/와인: 공포 +15%, SP +20%',
  synergy_noble_cellar: '귀족의 지하실',
  synergy_noble_cellar_desc: '와인저장고 + 비밀통로: 분위기 +15%, SP +10%',
  synergy_quarantine_protocol: '격리 프로토콜',
  synergy_quarantine_protocol_desc: '서버실/격리구역/무기고: 스릴 +20%, 공포 +10%',
  synergy_nature_wrath: '자연의 분노',
  synergy_nature_wrath_desc: '마녀/늪지/요정: 분위기 +20%, 위협 +10%',
  synergy_ancient_power: '고대의 힘',
  synergy_ancient_power_desc: '유적/요정/제단: 공포 +20%, 방문객 +15%',
  synergy_echo_chamber: '메아리 방',
  synergy_echo_chamber_desc: '음악실/도서관/복도: 연쇄 +25%, 분위기 +10%',
  synergy_water_horror: '물의 공포',
  synergy_water_horror_desc: '화장실/지하강/지하호수: 공포 +15%, 분위기 +15%',
  synergy_full_course: '풀코스',
  synergy_full_course_desc: '주방/화장실/음악실: 재미 +25%, 방문객 +20%',
  room_repair_needed: '수리가 필요함',
  room_repairing: '수리 중',
  room_cleaning: '청소 중',

  // === Ghost Management ===
  ghost_roster: '유령 목록',
  ghost_idle: '대기중',
  ghost_assigned: '배치됨',
  ghost_fatigue: '피로도',
  ghost_level: 'Lv.{n}',
  ghost_exp: '경험치 {cur}/{max}',
  ghost_level_up: '레벨업',
  recover_fatigue: '피로도 회복 ({sp} SP)',
  ghost_fatigued_warning: '탈진! 효율 -50%',
  unassign_ghost: '배치 해제',
  ghost_training_in_progress: '훈련 중...',

  // === Shop ===
  shop_ghosts: '유령 고용',
  shop_rooms: '방 타입',
  hire: '고용',
  hire_cost: '{sp} SP',
  already_hired: '고용완료',
  not_enough_sp: 'SP가 부족합니다!',
  unlock_room_type: '해금',
  unlock_cost: '{sp} SP',
  already_unlocked: '해금됨',

  // === Ghost Grades ===
  grade_c: 'C등급',
  grade_b: 'B등급',
  grade_a: 'A등급',
  grade_s: 'S등급',

  // === Ghost Names ===
  ghost_jinaeryeong: '처녀유령',
  ghost_gangsi: '강시',
  ghost_vampire: '뱀파이어',
  ghost_kappa: '갓파',
  ghost_pierrot: '피에로',
  ghost_banshee: '반시',

  // === Ghost Origins ===
  ghost_origin_korea: '한국',
  ghost_origin_china: '중국',
  ghost_origin_romania: '루마니아',
  ghost_origin_japan: '일본',
  ghost_origin_usa: '미국',
  ghost_origin_ireland: '아일랜드',

  // === Ghost Skills ===
  ghost_jinaeryeong_skill: '긴 머리 낙하: 천장에서 떨어져 물리 공포 추가',
  ghost_gangsi_skill: '경직 점프: 굳은 자세로 도약, 손님 2명 동시 공포',
  ghost_vampire_skill: '최면의 눈: 손님 1명을 10초 얼림, 다음 방 공포 +30%',
  ghost_kappa_skill: '접시 스핀: 머리 접시를 회전시켜 시각 공포',
  ghost_pierrot_skill: '웃음 공격: 갑작스러운 등장, 광대 공포',
  ghost_banshee_skill: '절규: 청각 공포 최강, 연속 발동 가능',

  // === Ghost Quotes ===
  ghost_jinaeryeong_quote: '오늘 손님 10명이나 놀래켰어요, 사장님!',
  ghost_gangsi_quote: '뛰어다니는 게 쉽지 않네요...',
  ghost_vampire_quote: '밤은 길고, 나는 영원하다.',
  ghost_kappa_quote: '물 흘리지 마라!',
  ghost_pierrot_quote: '왜 그렇게 심각해요?',
  ghost_banshee_quote: '소리를 너무 질러서 목이 아파요.',

  // === Ghost Fatigued Quotes ===
  ghost_jinaeryeong_fatigued: '사장님... 머리카락이 엉망이에요. 좀 쉬어야겠어요!',
  ghost_gangsi_fatigued: '더는 못 움직이겠어요... 진짜로요.',
  ghost_vampire_fatigued: '불사신도 쉬어야 해요...',
  ghost_kappa_fatigued: '접시가 말랐어요, 물이 필요해요!',
  ghost_pierrot_fatigued: '이제 웃을 수가 없어요, 사장님.',
  ghost_banshee_fatigued: '목소리가 나오질 않아요! 절규를 못 해요!',

  // === Room Build Popup ===
  room_unlock_in_shop: '상점에서 해금',

  // === Visitor Types ===
  visitor_scaredy_kid: '겁쟁이 어린이',
  visitor_scaredy_kid_desc: '쉽게 겁먹지만 적은 공포에도 만족',
  visitor_normal: '일반인',
  visitor_normal_desc: '평균적인 공포 내성',
  visitor_brave: '강심장',
  visitor_brave_desc: '높은 내성, 만족 시 큰 보상',
  visitor_couple: '커플',
  visitor_couple_desc: '적당한 공포, 높은 보상, 좋은 리뷰',
  visitor_youtuber: '유튜버',
  visitor_youtuber_desc: '리뷰 영향력 2.5배',
  visitor_exorcist: '퇴마사',
  visitor_exorcist_desc: '겁먹기 거의 불가능, 엄청난 보상',
  visitor_thrill_seeker: '스릴 추구자',
  visitor_thrill_seeker_desc: '강한 공포를 원함, 약한 공포에 실망',
  visitor_coward: '겁쟁이',
  visitor_coward_desc: '모든 것에 겁먹음, 쉽게 도주',

  // === Time Phase ===
  time_phase_day: '낮',
  time_phase_evening: '저녁',
  time_phase_night: '밤',
  time_phase_rain: '비',

  // === Reputation ===
  reputation_label: '평판: {n}',

  // === Scare Feedback ===
  scare_chain: '연속 x{n}!',
  terror_max: '공포 절정!',
  sp_earned: '+{sp} SP',

  // === Prestige ===
  prestige_title: '프랜차이즈 확장',
  prestige_desc: '유령의 집이 세계적으로 유명해졌습니다! 프랜차이즈를 개점할까요?',
  prestige_requirement_floors: '{n}층 이상 필요',
  prestige_requirement_fame: '명성 {n} 이상 필요',
  prestige_requirement_sp: '총 획득 SP {n} 이상 필요',
  prestige_not_ready: '조건 미충족',
  prestige_confirm: '프랜차이즈 개점',
  prestige_level: '프레스티지 Lv.{n}',
  prestige_bonus: '모든 유령 공포 +{n}%, 시작 SP +{sp}',

  // === Offline reward ===
  offline_collect: '수령',

  // === Training System ===
  training_title: '연기 수업',
  training_select: '훈련 선택',
  training_cost: '{sp} SP',
  training_duration: '{sec}초',
  training_in_progress: '훈련 진행 중...',
  training_complete: '훈련 완료!',
  training_bonus: '공포력 +{pct}%',
  training_skip_ad: '스킵 (광고)',
  training_count: '{n}회 수료',
  training_ghost_busy: '먼저 배치를 해제하세요',
  training_already: '이미 훈련 중',

  training_scream_practice: '비명 연습',
  training_scream_practice_desc: '발성과 타이밍 향상',
  training_jumpscare_acting: '점프스케어 연기',
  training_jumpscare_acting_desc: '갑작스러운 등장의 예술 습득',
  training_psychological_acting: '심리적 공포 연기',
  training_psychological_acting_desc: '지속적인 불안감 조성 학습',
  training_atmosphere_directing: '분위기 연출',
  training_atmosphere_directing_desc: '조명, 소리, 안개 큐 컨트롤',
  training_physical_training: '체력 훈련',
  training_physical_training_desc: '에너지 넘치는 공포를 위한 체력 단련',
  training_audience_analysis: '관객 분석',
  training_audience_analysis_desc: '최적의 공포를 위한 방문객 행동 연구',

  // === Training Comedy Quotes ===
  tq_jinaeryeong_scream: '처녀유령이 유튜브로 공포영화 연기 분석 중...',
  tq_gangsi_scream: '강시가 뻣뻣한 자세로 비명 연습 중...',
  tq_vampire_scream: '뱀파이어가 지하실에서 오페라 허밍 중...',
  tq_kappa_scream: '갓파가 양동이에서 수중 비명 연습 중...',
  tq_pierrot_scream: '피에로가 풍선에 대고 비명 연습 중...',
  tq_banshee_scream: '반시가 초보자들에게 마스터클래스 진행 중...',

  tq_jinaeryeong_jumpscare: '처녀유령이 반복적으로 옷장에서 튀어나오는 중...',
  tq_gangsi_jumpscare: '강시가 스트레칭 하며 점프 연습 중...',
  tq_vampire_jumpscare: '뱀파이어가 극적인 망토 펼치기 연습 중...',
  tq_kappa_jumpscare: '갓파가 변기에서 팝업 연습 중...',
  tq_pierrot_jumpscare: '피에로가 풍선 터뜨리기 타이밍 리허설 중...',
  tq_banshee_jumpscare: '반시가 등장 안무 연습 중...',

  tq_jinaeryeong_psych: '처녀유령이 심리학 교과서 공부 중...',
  tq_gangsi_psych: '강시가 소름끼치는 표정 연습 중 (이미 그런데)...',
  tq_vampire_psych: '뱀파이어가 거울 앞에서 표정 연습 중... (거울에 안 비침)',
  tq_kappa_psych: '갓파가 도서관 책으로 인간의 공포 학습 중...',
  tq_pierrot_psych: '피에로가 "그것"을 50번째 시청 중...',
  tq_banshee_psych: '반시가 소름끼치는 속삭임 대본 작성 중...',

  tq_jinaeryeong_atmo: '처녀유령이 최대 소름 효과를 위해 머리카락 정리 중...',
  tq_gangsi_atmo: '강시가 안개 기계 설정 조정 중...',
  tq_vampire_atmo: '뱀파이어가 완벽한 촛불 각도 선택 중...',
  tq_kappa_atmo: '갓파가 다양한 물방울 소리 테스트 중...',
  tq_pierrot_atmo: '피에로가 야광 페인트로 벽 칠하는 중...',
  tq_banshee_atmo: '반시가 복도 에코 효과 보정 중...',

  tq_jinaeryeong_physical: '처녀유령이 천장 기어다니기 운동 중...',
  tq_gangsi_physical: '강시가 뻣뻣한 다리로 스쿼트 중...',
  tq_vampire_physical: '뱀파이어가 관 속에서 팔굽혀펴기 중...',
  tq_kappa_physical: '갓파가 연못에서 수영 랩 중...',
  tq_pierrot_physical: '피에로가 윗몸일으키기 하면서 저글링 중...',
  tq_banshee_physical: '반시가 성대 워밍업 중...',

  tq_jinaeryeong_audience: '처녀유령이 온라인 방문자 리뷰 읽는 중...',
  tq_gangsi_audience: '강시가 방문자 동선 패턴 연구 중...',
  tq_vampire_audience: '뱀파이어가 공포 인구통계 분석 중...',
  tq_kappa_audience: '갓파가 어떤 연령대가 물을 무서워하는지 조사 중...',
  tq_pierrot_audience: '피에로가 광대공포증 통계 추적 중...',
  tq_banshee_audience: '반시가 음파 주파수 공포 반응 연구 중...',

  // === Props ===
  props_title: '방 소품',
  prop_buy: '구매 ({sp} SP)',
  prop_upgrade: '업그레이드 ({sp} SP)',
  prop_max: '최대',
  prop_level: 'Lv.{n}',
  prop_bonus: '+{pct}% 공포',

  prop_cobwebs: '거미줄',
  prop_cobwebs_desc: '클래식한 으스스한 분위기',
  prop_candles: '깜빡이는 촛불',
  prop_candles_desc: '으스스하게 춤추는 그림자',
  prop_blood_pool: '핏물 웅덩이',
  prop_blood_pool_desc: '소름끼치는 바닥 장식',
  prop_skull_decor: '해골 장식',
  prop_skull_decor_desc: '뼛속까지 서늘한 전시',
  prop_fog_machine: '안개 기계',
  prop_fog_machine_desc: '짙은 미스터리 안개',
  prop_creaky_floor: '삐걱대는 마루',
  prop_creaky_floor_desc: '걸을 때마다 소리',
  prop_eerie_painting: '소름끼치는 그림',
  prop_eerie_painting_desc: '따라오는 시선',
  prop_chains: '덜그럭 쇠사슬',
  prop_chains_desc: '으스스한 금속 소리',

  // Staging Equipment
  prop_dry_ice: '드라이아이스 기계',
  prop_dry_ice_desc: '바닥에 짙은 안개를 만들어 공포 분위기 연출',
  prop_scent_sprayer: '향기 분사기',
  prop_scent_sprayer_desc: '불쾌한 냄새로 공포 몰입감 극대화',
  prop_strobe_light: '스트로브 라이트',
  prop_strobe_light_desc: '깜빡이는 섬광으로 방문객 감각 교란',
  prop_surround_speaker: '서라운드 스피커',
  prop_surround_speaker_desc: '입체 음향으로 소름 돋는 효과음 재생',
  prop_vibration_floor: '진동 바닥판',
  prop_vibration_floor_desc: '발밑에서 갑작스러운 진동 발생',
  prop_temp_controller: '온도 조절기',
  prop_temp_controller_desc: '갑자기 불어오는 찬바람으로 심리적 공포',
  prop_hologram_device: '홀로그램 장치',
  prop_hologram_device_desc: '방 안에 유령의 환영을 투사',
  prop_auto_lock: '자동 문 잠금장치',
  prop_auto_lock_desc: '방문객 뒤에서 문이 갑자기 잠김',

  // Props categories
  props_category_decoration: '장식 소품',
  props_category_staging: '연출 도구',
  props_staging_desc: '전문적인 공포 연출을 위한 고급 장비',

  // === Facilities ===
  facilities_title: '부대시설',
  facility_build: '건설 ({sp} SP)',
  facility_upgrade: '업그레이드 ({sp} SP)',
  facility_level: 'Lv.{n}',
  facility_built: '건설됨',

  facility_haunted_house: '유령의 집',
  facility_haunted_house_desc: '공포 체험 메인 건물',
  facility_haunted_house_bonus: '메인 건물 입구',
  facility_enter: '입장',

  facility_ticket_booth: '매표소',
  facility_ticket_booth_desc: '방문객에게 입장권을 판매합니다',
  facility_ticket_booth_bonus: '최대 방문객 수 증가',
  facility_ticket_booth_visitors: '명',

  facility_gift_shop: '기념품 가게',
  facility_gift_shop_desc: '유령의 집 기념품 판매',
  facility_gift_shop_bonus: '방문객 그룹당 +{sp} SP',
  facility_snack_bar: '매점',
  facility_snack_bar_desc: '으스스한 간식과 음료',
  facility_snack_bar_bonus: '방문객 보상 +{pct}%',
  facility_photo_booth: '포토부스',
  facility_photo_booth_desc: '공포 셀카 촬영소',
  facility_photo_booth_bonus: '방문객 그룹당 +{sp} SP',

  // === Reviews ===
  reviews_title: '방문자 리뷰',
  reviews_empty: '아직 리뷰가 없습니다. 방문객을 기다리세요!',
  reviews_fame_bonus: '+{n} 명성',
  review_stars: '{n}점',
  reviews_avg: '평균: {n}점',

  review_5_1: '진짜 무서웠음. 특히 3층 {ghost} 연기력 ㄷㄷ',
  review_5_2: '역대 최고 유령의 집! 소리 지르다가 목 나감!',
  review_5_3: '{ghost} 연기가 오스카 감이었음! 10점 만점에 10점!',
  review_5_4: '영혼이 나갈 뻔함. 가성비 최고!',
  review_4_1: '{ghost} 꽤 무서웠는데, 윗층은 좀 더 기대했음.',
  review_4_2: '분위기 최고! 거의 오줌 쌀 뻔했음. 거의.',
  review_4_3: '{ghost} 인상적이었지만 타이밍이 좀 아쉬웠음.',
  review_4_4: '전체적으로 알찬 공포. 친구한테 추천!',
  review_3_1: '그럭저럭. 빈 방이 좀 있어서 분위기 깨짐.',
  review_3_2: '{ghost} 오늘 좀 피곤해 보였음. 좀 쉬세요?',
  review_3_3: '평범한 체험. 소품이 더 필요함.',
  review_2_1: '{ghost}가 일하다 말고 자고 있었음. 환불 요청',
  review_2_2: '무섭다기보다 웃김. 유령들 연기 수업 필요함.',
  review_2_3: '{ghost}가 최선을 다했지만... 전혀 안 무서웠음.',
  review_1_1: '빈 방 투성이. 여기 영업하는 거 맞아요?',
  review_1_2: '환불해주세요. 우리 할머니가 더 무서움.',
  review_1_3: '{ghost}가 저한테 손 흔들었음. 흔들었다고요. 그게 유령이냐.',

  // === Ad Rewards ===
  review_street_5star: '테마파크 전체가 완벽해요! 유령의 집도 무섭고 시설도 최고!',
  review_street_4star: '전반적으로 좋은 경험. 유령의 집 무섭고 간식도 맛있었어요.',
  review_street_3star: '그럭저럭. 유령의 집에 유령이 좀 더 있으면 좋겠어요.',
  review_street_2star: '할 게 별로 없어요. 유령의 집도 밋밋했어요.',
  review_street_1star: '시간 낭비. 무서운 것도 없고 시설도 별로.',

  review_vip_satisfied: 'VIP: Perfect! I will definitely come back with my friends.',
  review_vip_unsatisfied: 'VIP: Very disappointing experience. Not worth my time.',

  season_halloween: 'Halloween',
  season_summer_fest: 'Summer Fest',
  season_winter_chill: 'Winter Chill',
  season_spring_bloom: 'Spring Bloom',

  ad_sp_boost: 'SP 2배 부스트 (30초)',
  ad_sp_boost_desc: '30초간 모든 SP 수입 2배',
  ad_recover_fatigue: '무료 회복',
  ad_recover_fatigue_desc: '유령 피로도 즉시 무료 회복',
  ad_vip_visitor: 'VIP 방문객',
  ad_vip_visitor_desc: '높은 보상의 VIP 방문객 소환',
  ad_skip_training: '훈련 스킵',
  ad_skip_training_desc: '훈련 즉시 완료',
  ad_active_boost: '2배 SP 활성중!',
  ad_rewards_title: '광고 보상',

  // === Business / Open-Close System ===
  day_label: '{n}일차',
  hud_operation_day: '운영 {n}일째',
  status_open: '영업 중',
  status_closed: '영업 종료',
  manage_business: '\uac00\uac8c \uad00\ub9ac',
  toggle_open: '영업 시작',
  toggle_close: '영업 종료',
  facility_open_badge: '영업중',
  need_ghost_to_open: '유령을 방에 배치해야 오픈할 수 있습니다!',
  ticket_price: '입장료',
  ticket_price_label: '{n} SP',
  ticket_price_low: '손님 많음, 인당 수익 적음',
  ticket_price_high: '손님 적음, 인당 수익 많음',
  end_day: '하루 종료',
  day_summary_title: 'DAY {n} 결산',
  day_summary_visitors: '방문객: {n}명',
  day_summary_earnings: '수익: {n} SP',
  day_summary_avg_rating: '평균 별점: {n}',
  day_summary_next: '하루 종료 & 보상 수령',
  day_summary_best_visitor: '{n}점 방문!',
  day_summary_sp_collected: '총 SP 수집',
  day_summary_sp_gain: '+{n}',
  day_summary_milestones: '일일 목표',
  day_summary_total_visits: '총 방문',
  day_summary_street_visitors: '거리 방문객',
  day_summary_street_revenue: '거리 수익',
  day_summary_reaction_5: '공포 그 자체!',
  day_summary_reaction_4: '무섭다!',
  day_summary_reaction_3: '나쁘지 않음',
  day_summary_reaction_2: '글쎄...',
  day_summary_reaction_1: '지루함...',

  // === Daily Milestones ===
  milestone_visitors_5: '방문객 {target}명 맞이하기',
  milestone_visitors_10: '방문객 {target}명 맞이하기',
  milestone_visitors_20: '방문객 {target}명 맞이하기',
  milestone_earnings_1000: 'SP {target} 벌기',
  milestone_earnings_5000: 'SP {target} 벌기',
  milestone_earnings_10000: 'SP {target} 벌기',
  milestone_flee_0: '도주 손님 0명',
  milestone_flee_1: '도주 손님 {target}명 이하',
  milestone_rooms_3: '방 {target}개 이상 운영',
  milestone_rooms_5: '방 {target}개 이상 운영',
  milestone_ghosts_2: '유령 {target}명 이상 배치',
  milestone_ghosts_3: '유령 {target}명 이상 배치',
  milestone_reward: '+{n} SP',

  // === Review Panel ===
  reviews_panel_title: '방문자 리뷰',
  reviews_panel_avg: '평균 별점',
  reviews_panel_empty: '아직 리뷰가 없습니다',

  // --- Missing keys (English fallback) ---
  ghost_mummy: 'Mummy',
  ghost_werewolf: 'Werewolf',
  ghost_origin_egypt: 'Egypt',
  ghost_origin_europe: 'Europe',
  ghost_mummy_skill: 'Bandage Wrap: Entangles visitors, physical + visual scare',
  ghost_werewolf_skill: 'Full Moon Howl: Terrifying transformation, max physical + auditory',
  ghost_mummy_quote: 'These bandages are so itchy...',
  ghost_werewolf_quote: 'Is there a full moon tonight? I feel... different.',
  ghost_mummy_fatigued: 'My bandages came undone... I tripped...',
  ghost_werewolf_fatigued: 'Even wolves need sleep... woof... zzz...',
  tq_mummy_scream: 'Mummy practicing muffled screams through bandages...',
  tq_werewolf_scream: 'Werewolf howling at a picture of the moon...',
  tq_mummy_jumpscare: 'Mummy bursting out of sarcophagus repeatedly...',
  tq_werewolf_jumpscare: 'Werewolf practicing surprise transformations...',
  tq_mummy_psych: 'Mummy reading ancient curse scrolls for inspiration...',
  tq_werewolf_psych: 'Werewolf studying pack hunting psychology...',
  tq_mummy_atmo: 'Mummy arranging ancient Egyptian artifacts for ambiance...',
  tq_werewolf_atmo: 'Werewolf setting up moonlight projectors...',
  tq_mummy_physical: 'Mummy doing stretches to prevent bandage tangles...',
  tq_werewolf_physical: 'Werewolf doing 500 push-ups in wolf form...',
  tq_mummy_audience: 'Mummy researching which civilization visitors fear most...',
  tq_werewolf_audience: 'Werewolf tracking which visitors have dog allergies...',

  // === View Switcher ===
  view_building: '건물',
  view_other_buildings: '< 다른 건물 보기',
  view_lobby: '대기실',
  view_facilities: '부대시설',
  view_academy: '교육원',
  // === Lobby View ===
  lobby_title: '대기실',
  lobby_queue: '대기열',
  lobby_queue_empty: '대기 중인 손님이 없습니다',
  lobby_active_teams: '탐험 중: {cur}/{max}팀',
  lobby_wait_time: '대기: {n}초',
  lobby_team_size: '{n}명',
  lobby_staff: '로비 직원',
  lobby_staff_empty: '배치된 직원 없음',
  lobby_assign_staff: '직원 배치',
  lobby_unassign_staff: '해제',
  lobby_staff_effect: '대기 시간 감소, 손님 만족도 향상',
  lobby_ticket_booth: '매표소',
  // === Facilities View ===
  facilities_view_title: '시설 관리',
  facilities_view_empty: '건설된 시설이 없습니다. 메뉴에서 건설하세요!',
  facility_staff: '직원',
  facility_staff_none: '직원 없음',
  facility_assign_staff: '직원 배치',
  facility_unassign_staff: '직원 해제',
  facility_staff_bonus: '직원 배치 시 서비스 품질 향상',
  facility_restroom: '화장실',
  facility_restroom_desc: '만족도 페널티 방지',
  facility_restroom_bonus: '건설 시 페널티 없음',
  facility_parking_lot: '주차장',
  facility_parking_lot_desc: '손님 유입 증가',
  facility_parking_lot_bonus: '레벨당 손님 유입 +{pct}%',
  facility_first_aid: '응급실',
  facility_first_aid_desc: '도주/기절 손님 케어',
  facility_first_aid_bonus: '도주 시 나쁜 리뷰 방지',

  facility_arcade: '아케이드',
  facility_arcade_desc: '미니게임 & 공포 어트랙션',
  facility_arcade_bonus: '방문자 흥분도 증가',
  facility_fortune_teller: '점술관',
  facility_fortune_teller_desc: '신비로운 타로 & 손금 읽기',
  facility_fortune_teller_bonus: '방문자 만족도 향상',
  facility_escape_room: '탈출방',
  facility_escape_room_desc: '시간제한 공포 퍼즐 도전',
  facility_escape_room_bonus: '높은 방문자당 수익',
  facility_stage: '공연장',
  facility_stage_desc: '유령 공연 & 쇼',
  facility_stage_bonus: '파크 전체 명성 증가',
  facility_voodoo_shop: '부두 상점',
  facility_voodoo_shop_desc: '저주 인형과 어둠의 의식',
  facility_voodoo_shop_bonus: '인접 방 공포력 증가',
  facility_ghost_cafe: '유령 카페',
  facility_ghost_cafe_desc: '유령 음료와 유령 간식',
  facility_ghost_cafe_bonus: '방문자 인내심 회복',
  facility_phantom_cinema: '유령 극장',
  facility_phantom_cinema_desc: '공포 영화 상영',
  facility_phantom_cinema_bonus: '상영 당 높은 수익',
  facility_skeleton_spa: '해골 스파',
  facility_skeleton_spa_desc: '뼈가 시리도록 릴랙스',
  facility_skeleton_spa_bonus: '유령 피로도 감소',

  // === Academy View ===
  academy_title: '유령 교육원',
  academy_empty: '먼저 유령을 고용하세요!',
  academy_select_ghost: '교육할 유령을 선택하세요',
  academy_select_training: '교육 과정 선택',
  academy_skill_level: 'Lv.{n}/{max}',
  academy_skill_maxed: '마스터',
  academy_training_time: '{sec}초',
  academy_training_cost: '{sp} SP',
  academy_in_progress: '교육 중...',
  academy_complete: '완료!',
  academy_skip_ad: '건너뛰기 (광고)',
  academy_ghost_busy: '유령이 바쁩니다',
  academy_acting: '연기 수업',
  academy_acting_desc: '놀래키기 연기력 향상',
  academy_acting_effect: '레벨당 공포 효과 +20%',
  academy_human_relations: '인간 친화 교육',
  academy_human_relations_desc: '손님 이해도 향상',
  academy_human_relations_effect: '레벨당 만족도 +15%',
  academy_psychology: '심리학 강좌',
  academy_psychology_desc: '손님 약점 타격',
  academy_psychology_effect: '레벨당 약점 타격 보너스',
  academy_special_fx: '특수효과 실습',
  academy_special_fx_desc: '소품 활용 능력 향상',
  academy_special_fx_effect: '레벨당 소품 보너스 x2',
  academy_fitness: '체력 단련',
  academy_fitness_desc: '체력 및 지구력 향상',
  academy_fitness_effect: '레벨당 피로도 회복 +50%',
  academy_teamwork: '팀워크 훈련',
  academy_teamwork_desc: '인접 유령과 협동',
  academy_teamwork_effect: '레벨당 체인스케어 +30%',
  academy_customer_service: '고객 서비스',
  academy_customer_service_desc: '로비/시설 서비스 향상',
  academy_customer_service_effect: '레벨당 서비스 품질 향상',
  // === Facility Detail View ===
  facility_detail_income: '수입',
  facility_detail_sp_per_group: '그룹당 {n} SP',
  facility_detail_bonus: '보너스',
  facility_detail_upgrade: '업그레이드 ({sp} SP)',
  facility_detail_assign: '직원 배치',
  facility_detail_status_active: '운영 중',
  facility_detail_status_buildable: '건설 가능',
  facility_detail_status_locked: '잠김',
  facility_detail_no_income: '직접 수입 없음',
  // === Ghost Roles ===
  ghost_role_scare: '공포 담당',
  ghost_role_lobby_staff: '로비 직원',
  ghost_role_facility_staff: '시설 직원',
  ghost_role_instructor: '교관',
  // === Pro Ghosts ===
  shop_pro_ghosts: '프로페셔널 유령',
  pro_ghost_badge: 'PRO',
  ghost_grim_reaper: '저승사자',
  ghost_origin_underworld: '저승',
  ghost_grim_reaper_skill: '영혼 수확: 모든 공포 타입 S등급, 절대 공포',
  ghost_grim_reaper_quote: '너의 시간이 왔다... 농담이야. 아닐 수도?',
  ghost_grim_reaper_fatigued: '죽음도 가끔은 휴가가 필요해...',
  ghost_grim_reaper_unique: '모든 손님 타입에 즉시 최대 공포',
  ghost_blood_count: '흡혈 백작',
  ghost_origin_transylvania: '트란실바니아',
  ghost_blood_count_skill: '피의 매력: 카리스마형 시각+심리 S등급',
  ghost_blood_count_quote: '나는 와인을... 마시지 않는다.',
  ghost_blood_count_fatigued: '햇빛이... 타는 것 같아... 관이 필요해...',
  ghost_blood_count_unique: '매력 오라: 인접 방 공포 +20%',
  ghost_well_spirit: '우물의 혼령',
  ghost_well_spirit_skill: '우물 기어나오기: 심리 공포 S등급, 오래가는 공포',
  ghost_well_spirit_quote: '...7일...',
  ghost_well_spirit_fatigued: '머리카락이 너무 엉켰어... 린스가 필요해...',
  ghost_well_spirit_unique: '잔존 공포: 다음 방에서도 공포 유지',
  ghost_nightmare_specter: '악몽의 망령',
  ghost_origin_dreamworld: '꿈의 세계',
  ghost_nightmare_specter_skill: '악몽의 손톱: 물리+심리 S등급 꿈의 공포',
  ghost_nightmare_specter_quote: '좋은 꿈 꿔라... 아니면 말고.',
  ghost_nightmare_specter_fatigued: '악몽도 수면이 필요해...',
  ghost_nightmare_specter_unique: '꿈 침투: 잠든 손님에게 공포 2배',
  ghost_shadow_stalker: '그림자 추적자',
  ghost_origin_void: '공허',
  ghost_shadow_stalker_skill: '정적 존재: 심리 공포 최강, 스토커형',
  ghost_shadow_stalker_quote: '...',
  ghost_shadow_stalker_fatigued: '......',
  ghost_shadow_stalker_unique: '정적 오라: 같은 층 모든 손님 공포 +15%',

  // === Visitor Reactions ===
  reaction_angry: '#!',
  reaction_excited: '*',

  // === Lobby Building System ===
  lobby_room_ticket_booth: '매표소',
  lobby_room_ticket_booth_desc: '방문객이 티켓을 구매하는 곳',
  lobby_room_ticket_booth_effect: '기본 티켓 처리 속도',
  lobby_room_waiting_lounge: '대기 라운지',
  lobby_room_waiting_lounge_desc: '편안한 좌석이 있는 대기 공간',
  lobby_room_waiting_lounge_effect: '레벨당 방문객 인내심 +20%',
  lobby_room_vip_lounge: 'VIP 라운지',
  lobby_room_vip_lounge_desc: 'VIP 방문객 전용 프리미엄 대기실',
  lobby_room_vip_lounge_effect: 'VIP 방문객 SP 2배 소비',
  lobby_room_reservation_center: '예약 센터',
  lobby_room_reservation_center_desc: '방문객 사전 예약 시스템',
  lobby_room_reservation_center_effect: '레벨당 방문객 출현율 +15%',

  lobby_build_floor: '+ {name} ({sp} SP)',
  lobby_build_select: '건설할 시설 선택...',
  lobby_add_floor: '+ {sp} SP',
  lobby_empty_floor: '시설 건설',
  lobby_select_facility: '시설 선택',
  lobby_props_count: '소품 {n}개',
  lobby_props_title: '오브젝트',
  lobby_tab_info: '정보',
  lobby_tab_objects: '오브젝트',
  lobby_tab_upgrade: '업그레이드',
  lobby_tab_demolish: '폐기',
  lobby_demolish_confirm: '이 시설을 제거하시겠습니까? 층은 유지되며 빈 층이 됩니다.',
  lobby_demolish_btn: '시설 폐기',
  lobby_no_ghost: '직원 없음',
  lobby_upgrade_max: '최대 레벨',
  lobby_upgrade_next: 'Lv.{from} -> Lv.{to}',
  lobby_upgrade_effect: '업그레이드 후 효과:',
  facility_build_floor: '건설',

  // === Facility Map (Plot Grid) ===
  facility_map_title: '부대시설 구역',
  facility_build_here: '건설',
  facility_select_to_build: '시설 선택',
  facility_all_built: '모든 시설이 건설되었습니다.',
  facility_unlock_plot: '{sp} SP',
  facility_unlock_plot_title: '구역 해금',
  facility_unlock_plot_desc: '{sp} SP로 이 구역을 해금하여 새 시설을 건설할 수 있습니다.',
  facility_unlock_plot_btn: '해금 ({sp} SP)',
  facility_build_popup_title: '시설 건설',
  facility_build_action: '건설',
  facility_select_theme: '테마 선택',
  facility_upgrade_preview: '업그레이드 효과',
  facility_upgrade_revenue: '그룹당 수익',
  facility_upgrade_bonus: '수익 보너스',
  facility_upgrade_capacity: '수용량',
  facility_upgrade_current: '현재',
  facility_upgrade_next: '다음',
  facility_upgrade_max_level: '최대 레벨 도달',
  facility_revenue: '매출',
  facility_total_revenue: '총 매출',
  facility_hourly_revenue: '그룹당',
  facility_set_price: '가격 설정',
  facility_price_hint_high: '높은 가격: 수익 증가, 이용률 감소',
  facility_price_hint_low: '낮은 가격: 이용률 증가, 수익 감소',
  facility_price_hint_free: '무료 입장',
  facility_price_hint_normal: '적절한 가격',
  facility_open: '오픈',
  facility_close: '닫기',
  facility_closed_badge: '휴업중',
  facility_needs_staff: '직원을 배치해야 오픈 가능',
  facility_demolish: '폐기',
  facility_demolish_confirm: '{name}을(를) 폐기할까요? 되돌릴 수 없습니다.',
  facility_move: '이동',
  facility_move_select: '이동할 빈 구역을 선택하세요',
  facility_move_no_empty: '빈 구역이 없습니다.',

  // === Lobby Props ===
  lobby_prop_sofa: '소파',
  lobby_prop_sofa_desc: '대기 방문객을 위한 편안한 좌석',
  lobby_prop_tv_screen: 'TV 스크린',
  lobby_prop_tv_screen_desc: '대기 중 즐길 거리',
  lobby_prop_vending_machine: '자판기',
  lobby_prop_vending_machine_desc: '방문객을 위한 간식과 음료',
  lobby_prop_info_sign: '안내 간판',
  lobby_prop_info_sign_desc: '방문객을 안내하는 표지판',
  lobby_prop_potted_plant: '화분',
  lobby_prop_potted_plant_desc: '으스스한 초록빛 인테리어',
  lobby_prop_umbrella_stand: '우산꽂이',
  lobby_prop_umbrella_stand_desc: '젖은 우산을 보관하는 곳',

  // === Facility Props ===
  fac_prop_display_shelf: '진열대',
  fac_prop_display_shelf_desc: '상품을 매력적으로 전시',
  fac_prop_cash_register: '금전 등록기',
  fac_prop_cash_register_desc: '거래 속도 향상',
  fac_prop_coffee_machine: '커피 머신',
  fac_prop_coffee_machine_desc: '따뜻한 음료 제공',
  fac_prop_menu_board: '메뉴판',
  fac_prop_menu_board_desc: '음식과 음료 메뉴 표시',
  fac_prop_camera_light: '카메라 조명',
  fac_prop_camera_light_desc: '더 나은 사진 조명',
  fac_prop_backdrop: '배경막',
  fac_prop_backdrop_desc: '테마 사진 배경',
  fac_prop_hand_dryer: '핸드 드라이어',
  fac_prop_hand_dryer_desc: '깨끗하고 건조하게',
  fac_prop_mirror: '거울',
  fac_prop_mirror_desc: '으스스한 화장실 필수품',
  fac_prop_parking_sign: '주차 안내판',
  fac_prop_parking_sign_desc: '방문객을 주차장으로 안내',
  fac_prop_barrier_gate: '차단기',
  fac_prop_barrier_gate_desc: '자동 주차 관리',
  fac_prop_first_aid_kit: '구급상자',
  fac_prop_first_aid_kit_desc: '기본 의료 용품',
  fac_prop_stretcher: '들것',
  fac_prop_stretcher_desc: '공포에 기절한 방문객용',

  // === New Tab Names ===
  tab_facilities: '시설',
  tab_hire: '채용',
  tab_staff: '직원',
  tab_support_facilities: '부대시설',
  tab_achievements: '업적',
  achievements_title: '업적',
  achievements_coming_soon: '준비 중...',

  // === Facilities Management Tab ===
  facilities_mgmt_title: '시설 관리',
  facility_condition: '노후도',
  facility_hygiene: '위생도',
  facility_condition_warning: '수리가 필요합니다!',
  facility_hygiene_warning: '청소가 필요합니다!',
  dispatch_repair: '수리 파견',
  dispatch_clean: '청소 파견',
  no_repair_staff: '수리 직원이 없습니다',
  no_janitor_staff: '청소 직원이 없습니다',
  repair_dispatched: '수리 직원을 파견했습니다',
  clean_dispatched: '청소 직원을 파견했습니다',

  // === Ticket Price Section ===
  ticket_section_title: '입장료',
  expected_visitors: '예상 손님: ~{n}명/일',

  // === Star Evolution System ===
  star_rating_title: '손님 평가',
  star_level_gray: '회색별',
  star_level_bronze: '동별',
  star_level_silver: '은별',
  star_level_gold: '금별',
  star_level_rainbow: '무지개별',
  star_evolution_max: '최고의 유령의 집',
  star_current: '{cur}/{max}',

  // === Hire Tab ===
  hire_title: '직원 채용',
  hire_scare_section: '공포 전문가',
  hire_staff_section: '시설 직원',
  staff_role_repair: '수리공',
  staff_role_janitor: '청소부',
  staff_role_ticket: '매표원',
  staff_role_guide: '안내원',
  staff_role_repair_desc: '시설 노후화를 수리합니다',
  staff_role_janitor_desc: '시설 위생도를 관리합니다',
  staff_role_ticket_desc: '로비를 운영합니다',
  staff_role_guide_desc: '손님 만족도 보너스',
  hire_cost_label: '{sp} SP',

  // === Staff Tab ===
  staff_title: '직원 목록',
  staff_empty: '고용된 직원이 없습니다.',
  staff_detail_title: '직원 상세',
  staff_detail_type: '종류',
  staff_detail_role: '역할',
  staff_detail_grade: '등급',
  staff_detail_skills: '숙련도',
  staff_detail_assigned: '배치 위치',
  staff_detail_not_assigned: '미배치',
  staff_detail_hired_days: '입사: Day {n}',
  staff_detail_praise: '칭찬: {n}회',
  skill_acting: '연기력',
  skill_friendliness: '친화력',
  skill_psychology: '심리학',
  skill_special_fx: '특수효과',
  skill_fitness: '체력',
  skill_teamwork: '팀워크',
  skill_service: '고객서비스',

  // === Room Detail Popup ===
  room_detail_tab_info: '방 정보',
  room_detail_tab_props: '시설물',
  room_detail_tab_upgrade: '업그레이드',
  room_detail_tab_demolish: '폐기',
  room_detail_ghost_none: '배치 안 됨',
  room_detail_condition: '내구도',
  room_detail_hygiene: '청결도',
  room_detail_request_repair: '수리 요청 ({sp} SP)',
  room_detail_request_cleaning: '청소 요청 ({sp} SP)',
  room_detail_repairing: '수리 중... {sec}초',
  room_detail_cleaning: '청소 중... {sec}초',
  room_detail_collapsed: '붕괴됨',
  room_detail_collapsed_desc: '방이 붕괴되었습니다. 수리하면 복구됩니다.',
  room_detail_condition_ok: '내구도 양호',
  room_detail_hygiene_ok: '청결도 양호',
  // Upgrade tab
  room_upgrade_structure: '구조 보강',
  room_upgrade_structure_desc: '방문당 내구도 감소량 줄임',
  room_upgrade_structure_effect: '레벨당 내구도 감소 -{pct}%',
  room_upgrade_structure_bonus_10: '튼튼한 방: 수리 비용 -30%',
  room_upgrade_structure_bonus_20: '불멸의 방: 내구도 최소 50 유지',
  room_upgrade_purify: '자동 정화',
  room_upgrade_purify_desc: '방문당 청결도 감소량 줄임',
  room_upgrade_purify_effect: '레벨당 청결도 감소 -{pct}%',
  room_upgrade_purify_bonus_10: '향긋한 방: 만족도 +10%',
  room_upgrade_purify_bonus_20: '자가 청소 마법: 청결도 자동 회복',
  room_upgrade_level: 'Lv.{cur}/{max}',
  room_upgrade_cost: '업그레이드 ({sp} SP)',
  room_upgrade_max: '최대',
  room_upgrade_bonus_unlocked: '해금됨!',
  room_upgrade_bonus_locked: 'Lv.{n} 보너스',
  // Demolish tab
  room_demolish_warning: '이 방을 폐기하면 모든 시설물과 업그레이드가 사라집니다.',
  room_demolish_cost: '비용: 무료',
  room_demolish_btn: '폐기하기',
  room_demolish_confirm: '정말로 이 방을 폐기하시겠습니까? 되돌릴 수 없습니다.',
  // Props tab (in room detail)
  room_props_installed: '설치된 소품',
  room_props_available: '설치 가능한 소품',
  room_props_none: '설치된 소품 없음',

  // === Menu Tab (New) ===
  menu_bgm: 'BGM',
  menu_sfx: 'SFX',
  menu_language: '언어',
  menu_reset: '게임 초기화',
  menu_reset_confirm: '정말 모든 진행 상황을 초기화하시겠습니까? 되돌릴 수 없습니다.',
  menu_info: '게임 정보',
  menu_version: '버전 {v}',
  menu_on: 'ON',
  menu_off: 'OFF',

  // === Room Emotion Stats ===
  stat_fear: '공포도',
  stat_thrill: '스릴',
  stat_atmosphere: '분위기',
  stat_fun: '재미',
  stat_total: '방 스탯',
  room_grade: '등급',
  grade_S: 'S',
  grade_A: 'A',
  grade_B: 'B',
  grade_C: 'C',
  grade_D: 'D',
  grade_F: 'F',

  // === Day Phase Cycle ===
  phase_day: '\uC900\uBE44',
  phase_evening: '\uC601\uC5C5\uC911',
  phase_night: '\uB9C8\uAC10',
  phase_day_icon: '\u2600',
  phase_evening_icon: '\uD83C\uDF19',
  phase_night_icon: '\u2B50',
  phase_remaining: '{sec}\uCD08',
  phase_day_hint: '\uADC0\uC2E0\uC758 \uC9D1\uC744 \uC900\uBE44\uD558\uC138\uC694! \uC218\uB9AC, \uADC0\uC2E0 \uBC30\uCE58, \uC5C5\uADF8\uB808\uC774\uB4DC.',
  phase_evening_hint: '\uC601\uC5C5 \uC2DC\uAC04! \uC190\uB2D8\uC774 \uC624\uACE0 \uC788\uC2B5\uB2C8\uB2E4.',
  open_now_btn: '\uC601\uC5C5 \uC2DC\uC791',
  speed_btn: 'x{n}',
  day_auto_open_hint: '\uC800\uB141\uC774 \uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC601\uC5C5\uC744 \uC2DC\uC791\uD558\uC138\uC694.',
  evening_ending_hint: '\uB9C8\uAC10 \uC2DC\uAC04! \uC815\uB9AC \uC911...',
  floor1_blocked_warning: '\uC785\uC7A5 \uBD88\uAC00! 1\uCE35\uC744 \uC218\uB9AC\uD558\uC138\uC694!',

  // === Ghost Staff ===
  gstaff_title: '\uc720\ub839 \uc9c1\uc6d0',
  gstaff_repairman: '\uc218\ub9ac \uc720\ub839',
  gstaff_repairman_desc: '\ubcbd\uc744 \ud1b5\uacfc\ud558\uba70 \ubc29\uc744 \uc218\ub9ac\ud558\ub294 \uc720\ub2a5\ud55c \uc720\ub839',
  gstaff_repairman_effect: '\uac00\uc7a5 \ub0b4\uad6c\ub3c4\uac00 \ub0ae\uc740 \ubc29 \uc790\ub3d9 \uc218\ub9ac',
  gstaff_janitor: '\uccad\uc18c \uc720\ub839',
  gstaff_janitor_desc: '\uc601\ud63c\uc758 \ud798\uc73c\ub85c \ubc29\uc744 \uae68\ub057\uc774 \uccad\uc18c\ud569\ub2c8\ub2e4',
  gstaff_janitor_effect: '\uac00\uc7a5 \uccad\uacb0\ub3c4\uac00 \ub0ae\uc740 \ubc29 \uc790\ub3d9 \uccad\uc18c',
  gstaff_promoter: '\ud64d\ubcf4 \uc720\ub839',
  gstaff_promoter_desc: '\uc73c\uc2a4\uc2a4\ud55c \uc18d\uc0ad\uc784\uc73c\ub85c \uc190\ub2d8\uc744 \uc720\uc778\ud569\ub2c8\ub2e4',
  gstaff_promoter_effect: '\ub808\ubca8\ub2f9 \ubc29\ubb38\uac1d +20%',
  gstaff_medic: '\uce58\uc720 \uc720\ub839',
  gstaff_medic_desc: '\uacb8\uba39\uc740 \uc190\ub2d8\uc744 \uc720\ub839\uc758 \ub9e4\ub825\uc73c\ub85c \uc9c4\uc815\uc2dc\ud0b5\ub2c8\ub2e4',
  gstaff_medic_effect: '\ub3c4\uc8fc \uc190\ub2d8 \ub9ac\ubdf0\ub97c \uc911\ub9bd\uc73c\ub85c \ubcc0\uacbd',
  gstaff_security: '\uacbd\ube44 \uc720\ub839',
  gstaff_security_desc: '\uc704\uc555\uc801\uc778 \uc874\uc7ac\uac10\uc73c\ub85c \uc9c8\uc11c\ub97c \uc720\uc9c0\ud569\ub2c8\ub2e4',
  gstaff_security_effect: '\ub808\ubca8\ub2f9 \ub9cc\uc871\ub3c4 +10%',
  gstaff_hire_cost: '\uc18c\ud658: {sp} SP',
  gstaff_salary: '\uc720\uc9c0\ube44: {sp} SP/\uc77c',
  gstaff_fire: '\ud1f4\ub9c8',
  gstaff_fire_confirm: '\uc774 \uc720\ub839 \uc9c1\uc6d0\uc744 \ud1f4\ub9c8\ud560\uae4c\uc694?',
  gstaff_level: 'Lv.{n}',
  gstaff_none: '\uc18c\ud658\ub41c \uc720\ub839 \uc9c1\uc6d0\uc774 \uc5c6\uc2b5\ub2c8\ub2e4.',

  // === Day Summary Salary ===
  day_summary_salaries: '\uC9C1\uC6D0 \uAE09\uC5EC',
  day_summary_net_earnings: '\uC21C\uC218\uC775',
  day_summary_reviews_title: '\uBC29\uBB38\uAC1D \uB9AC\uBDF0',
  day_summary_avg_stars: '\uD3C9\uADE0 \uBCC4\uC810',
  day_summary_fame_change: '\uBA85\uC131',
  day_summary_no_reviews: '\uC624\uB298 \uB9AC\uBDF0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4',
  day_summary_review_visitor: '\uBC29\uBB38\uAC1D #{n}',
  day_summary_highlight: '\uD558\uC774\uB77C\uC774\uD2B8',

  // === Tutorial ===
  tutorial_welcome_title: '\uD658\uC601\uD569\uB2C8\uB2E4, \uC0AC\uC7A5\uB2D8!',
  tutorial_welcome_body: '\uADC0\uC2E0\uB4E4\uC774 \uBC30\uAC00 \uACE0\uD504\uACE0 \uBC31\uC218 \uC0C1\uD0DC\uC5D0\uC694! \uADC0\uC2E0\uC758 \uC9D1 \uC0AC\uC5C5\uC744 \uB3C4\uC640\uC8FC\uC138\uC694.',
  tutorial_welcome_btn: '\uC2DC\uC791\uD558\uC790!',
  tutorial_build_title: '\uBC29 \uB9CC\uB4E4\uAE30',
  tutorial_build_body: '\uBE48 \uCE35\uC744 \uD0ED\uD574\uC11C \uBC29\uC744 \uB9CC\uB4E4\uC5B4 \uBCF4\uC138\uC694. \uADC0\uC2E0\uB4E4\uC758 \uC77C\uD130\uAC00 \uD544\uC694\uD574\uC694!',
  tutorial_ghost_title: '\uADC0\uC2E0 \uBC30\uCE58\uD558\uAE30',
  tutorial_ghost_body: '\uBC29\uC744 \uD0ED\uD558\uACE0 \uADC0\uC2E0\uC744 \uBC30\uCE58\uD558\uC138\uC694. \uC190\uB2D8\uC744 \uC5F4\uC2EC\uD788 \uB180\uB798\uCF1C \uC904 \uAC70\uC608\uC694!',
  tutorial_open_title: '\uAC1C\uC7A5\uD558\uAE30!',
  tutorial_open_body: '"Ready" \uBC84\uD2BC\uC744 \uB20C\uB7EC\uC11C \uADC0\uC2E0\uC758 \uC9D1\uC744 \uC5F4\uACE0 \uC190\uB2D8\uC744 \uB9DE\uC774\uD558\uC138\uC694.',
  tutorial_facility_intro_title: '\uBD80\uB300\uC2DC\uC124 \uAD6C\uC5ED',
  tutorial_facility_intro_body: '\uD30C\uD06C\uC5D0\uB294 \uBD80\uB300\uC2DC\uC124\uC744 \uAC74\uC124\uD560 \uC218 \uC788\uB294 \uAD6C\uC5ED\uC774 \uC788\uC5B4\uC694! \uC0C1\uC810\uACFC \uB180\uC774\uC2DC\uC124\uC744 \uC9C0\uC5B4\uC11C \uB354 \uB9CE\uC740 \uC218\uC775\uC744 \uC62C\uB824\uBCF4\uC138\uC694.',
  tutorial_facility_build_title: '\uC2DC\uC124 \uAC74\uC124',
  tutorial_facility_build_body: '\uBE48 \uAD6C\uC5ED\uC744 \uD0ED\uD558\uACE0 \uC2DC\uC124\uC744 \uC120\uD0DD\uD558\uC138\uC694. \uAE30\uB150\uD488\uC810\uC774\uB098 \uC2A4\uB0B5\uBC14\uB97C \uCD94\uCC9C\uD574\uC694!',
  tutorial_facility_staff_title: '\uC9C1\uC6D0 \uBC30\uCE58',
  tutorial_facility_staff_body: '\uC0C8 \uC2DC\uC124\uC5D0 \uADC0\uC2E0\uC744 \uBC30\uCE58\uD558\uC138\uC694. \uC9C1\uC6D0\uC774 \uC788\uC73C\uBA74 \uC218\uC775\uC774 20% \uC99D\uAC00\uD574\uC694!',
  tutorial_facility_open_title: '\uC2DC\uC124 \uC624\uD508',
  tutorial_facility_open_body: '\uC2DC\uC124\uC744 \uC624\uD508\uD558\uBA74 \uBC29\uBB38\uAC1D\uC774 \uC774\uC6A9\uD560 \uC218 \uC788\uC5B4\uC694. \uAC00\uACA9\uB3C4 \uC124\uC815\uD560 \uC218 \uC788\uC5B4\uC694!',
  tutorial_done_title: '\uC900\uBE44 \uC644\uB8CC!',
  tutorial_done_body: '\uC190\uB2D8\uC774 \uC640\uC11C \uB180\uB77C\uACE0, \uB3C8\uC744 \uB0B4\uACE0 \uAC11\uB2C8\uB2E4. \uBC29\uC744 \uC5C5\uADF8\uB808\uC774\uB4DC\uD558\uACE0 \uADC0\uC2E0\uC744 \uB354 \uACE0\uC6A9\uD574\uC11C \uC0AC\uC5C5\uC744 \uD0A4\uC6CC\uBCF4\uC138\uC694!',
  tutorial_skip: '\uD29C\uD1A0\uB9AC\uC5BC \uAC74\uB108\uB6F0\uAE30',
  tutorial_next: '\uB2E4\uC74C',
  tutorial_got_it: '\uC54C\uACA0\uC5B4\uC694!',

  // === Story Arc System ===
  story_intro: '\uAE30',
  story_rising: '승',
  story_climax: '전',
  story_resolution: '결',
  story_grade: '동선 등급: {grade} (+{bonus}% SP)',
  story_bonus: '+{bonus}% SP',
  story_guide_title: '기승전결 동선 시스템 해금!',
  story_guide_desc: '4개 이상의 방을 운영하면 기승전결 동선 보너스 SP를 받을 수 있습니다!',
  story_role_label: '{role}',
  story_intro_desc: '분위기 조성: 높은 분위기, 낮은 공포',
  story_rising_desc: '긴장감 상승: 공포와 스릴 증가',
  story_climax_desc: '최고조의 공포: 공포와 스릴 극대화',
  story_resolution_desc: '해소와 재미: 재미 스탯 강화',
  story_room_role: '동선 역할: {role}',
  story_none: '없음',

  // === Room Available Props ===
  room_available_props: '설치 가능: {props}',

  // === Lobby Queue System ===
  lq_waiting_count: '대기: {n}/{max}',
  lq_avg_patience: '평균 인내심: {n}%',
  lq_queue_empty: '대기열에 손님이 없습니다',

  // === Lobby Facilities ===
  lf_title: '로비 시설',
  lf_patience_bonus: '인내심 -{n}%',
  lf_revenue_bonus: '+{n} SP/손님',
  lf_npc_bonus: 'NPC 직원: 인내심 +15%, 수익 +20%',
  lf_npc_staff: 'NPC 직원',

  lf_ticket_booth: '매표소',
  lf_ticket_booth_desc: '필수 티켓 발권 카운터',
  lf_waiting_lounge: '대기 라운지',
  lf_waiting_lounge_desc: '편안한 좌석이 있는 대기 공간 (+인내심)',
  lf_vip_lounge: 'VIP 라운지',
  lf_vip_lounge_desc: 'VIP 방문객 전용 프리미엄 대기실',
  lf_reservation_center: '예약 센터',
  lf_reservation_center_desc: '방문객 사전 예약 시스템 (+인내심)',
  lf_poster_wall: '포스터 벽',
  lf_poster_wall_desc: '으스스한 포스터가 기대감을 높입니다 (+인내심)',
  lf_snack_cart: '간식 카트',
  lf_snack_cart_desc: '간식으로 손님의 인내심을 유지합니다',
  lf_souvenir_booth: '기념품 부스',
  lf_souvenir_booth_desc: '기념품 판매로 추가 수익',
  lf_photo_zone: '포토존',
  lf_photo_zone_desc: '사진 촬영으로 명성과 수익 증가',
  lf_tv_monitor: 'TV 모니터',
  lf_tv_monitor_desc: '공포 하이라이트 영상으로 지루함 감소',
  lf_costume_rental: '의상 대여',
  lf_costume_rental_desc: '코스튬 대여로 재미와 수익 추가',
  lf_fortune_booth: '점술 부스',
  lf_fortune_booth_desc: '신비로운 점술이 공포 분위기를 조성합니다',
  lf_built_badge: '건설됨',

  // === Lobby Facility Unique Effects ===
  lf_ue_ticket_speed: '매표 속도: 레벨당 입장 간격 -15%',
  lf_ue_max_queue_up: '수용 인원: 레벨당 최대 대기 인원 +5',
  lf_ue_vip_rate_up: 'VIP 비율: 레벨당 VIP 손님 출현율 x2',
  lf_ue_satisfaction_up: '기대감: 기본 만족도 +20%',
  lf_ue_emergency_patience: '긴급 간식: 인내심 낮은 손님에게 +15 회복',
  lf_ue_revisit_rate_up: '기념품: 다음 날 손님 유입 +15%',
  lf_ue_reputation_per_day: 'SNS 공유: 레벨당 일일 평판 +2',
  lf_ue_anticipation_up: '공포 미리보기: 기대감 +40%',
  lf_ue_fun_bonus: '의상: 레벨당 재미 스탯 +15',
  lf_ue_random_sp_bonus: '점술: 랜덤 보너스 SP 확률 +10%',
  ticket_price_setting: '입장료 설정',

  // === Lobby Facility Props ===
  lobby_prop_candle: '촛불',
  lobby_prop_candle_desc: '분위기를 위한 깜빡이는 촛불',
  lobby_prop_cobweb: '거미줄',
  lobby_prop_cobweb_desc: '으스스하게 드리운 거미줄',
  lobby_prop_pumpkin: '호박',
  lobby_prop_pumpkin_desc: '고전적인 호박 랜턴',
  lobby_prop_magazine_rack: '잡지꽂이',
  lobby_prop_magazine_rack_desc: '대기 중 읽을 공포 잡지',
  lobby_prop_chandelier: '샹들리에',
  lobby_prop_chandelier_desc: '우아한 고딕 샹들리에',
  lobby_prop_wine_glass: '와인잔',
  lobby_prop_wine_glass_desc: 'VIP 분위기를 위한 크리스탈 와인잔',
  lobby_prop_velvet_curtain: '벨벳 커튼',
  lobby_prop_velvet_curtain_desc: '고급스러운 벨벳 드레이프',
  lobby_prop_gold_frame: '골드 프레임',
  lobby_prop_gold_frame_desc: '화려한 금빛 액자',
  lobby_prop_picture_frame: '액자',
  lobby_prop_picture_frame_desc: '벽에 걸린 저주받은 초상화',
  lobby_prop_spotlight: '조명',
  lobby_prop_spotlight_desc: '전시물을 위한 극적인 조명',
  lobby_prop_skull_ornament: '해골 장식',
  lobby_prop_skull_ornament_desc: '으스스한 분위기의 장식용 해골',
  lobby_prop_pumpkin_cookie: '호박 쿠키',
  lobby_prop_pumpkin_cookie_desc: '맛있는 호박 모양 쿠키',
  lobby_prop_ghost_drink: '유령 음료',
  lobby_prop_ghost_drink_desc: '신비롭게 빛나는 음료',
  lobby_prop_napkin_holder: '냅킨 홀더',
  lobby_prop_napkin_holder_desc: '간식 코너를 깔끔하게 유지',
  lobby_prop_display_shelf: '진열대',
  lobby_prop_display_shelf_desc: '기념품을 매력적으로 전시',
  lobby_prop_plush_doll: '인형',
  lobby_prop_plush_doll_desc: '귀여운 유령 봉제 인형',
  lobby_prop_keychain_rack: '열쇠고리 진열대',
  lobby_prop_keychain_rack_desc: '으스스한 열쇠고리 회전 진열대',
  lobby_prop_wrapping_paper: '포장지',
  lobby_prop_wrapping_paper_desc: '할로윈 테마 선물 포장지',
  lobby_prop_backdrop: '배경판',
  lobby_prop_backdrop_desc: '테마 사진 배경',
  lobby_prop_prop_box: '소품 상자',
  lobby_prop_prop_box_desc: '재미있는 사진 소품 상자',
  lobby_prop_mask_stand: '마스크 진열대',
  lobby_prop_mask_stand_desc: '사진용 무서운 마스크 전시',
  lobby_prop_antenna: '안테나',
  lobby_prop_antenna_desc: 'TV 신호 수신기',
  lobby_prop_remote_control: '리모컨',
  lobby_prop_remote_control_desc: 'TV 채널 제어',
  lobby_prop_speaker: '스피커',
  lobby_prop_speaker_desc: '공포 영상을 위한 서라운드 사운드',
  lobby_prop_cable_wires: '배선',
  lobby_prop_cable_wires_desc: '엉킨 전선이 으스스한 느낌을 더함',
  lobby_prop_clothes_rack: '옷걸이',
  lobby_prop_clothes_rack_desc: '으스스한 의상이 걸린 옷걸이',
  lobby_prop_mirror: '거울',
  lobby_prop_mirror_desc: '의상 확인용 전신 거울',
  lobby_prop_makeup_table: '분장대',
  lobby_prop_makeup_table_desc: '으스스한 분장을 하는 곳',
  lobby_prop_wig_stand: '가발 거치대',
  lobby_prop_wig_stand_desc: '무서운 가발 컬렉션',
  lobby_prop_crystal_ball: '크리스탈 볼',
  lobby_prop_crystal_ball_desc: '으스스한 미래를 들여다보세요',
  lobby_prop_tarot_cards: '타로 카드',
  lobby_prop_tarot_cards_desc: '신비로운 점술 카드',
  lobby_prop_curtain: '커튼',
  lobby_prop_curtain_desc: '점술 부스를 위한 신비로운 커튼',
  lobby_prop_candelabra: '촛대',
  lobby_prop_candelabra_desc: '분위기를 위한 다중 촛대',

  // === Lobby NPC Ghost ===
  lnpc_title: '로비 유령 순찰',
  lnpc_assign: '유령 배치',
  lnpc_unassign: '해제',
  lnpc_desc: '유령이 대기 중인 손님을 놀래켜 인내심을 회복시킵니다',
  lnpc_slot: '{cur}/{max} 유령',

  // === Random Event System ===
  evt_time_remaining: '{sec}초 남음',

  // Tier 1
  evt_rain_name: '갑작스러운 비',
  evt_rain_desc: '갑자기 폭우가 쏟아집니다. 우산 없는 손님들이 줄에서 떠나고 있습니다.',
  evt_rain_c1: '무시',
  evt_rain_c2: '우산 나눠주기 (100 SP)',
  evt_rain_r1: '3명의 손님이 비를 맞고 떠났습니다.',
  evt_rain_r2: '우산을 나눠줬습니다. 모두 무사합니다.',

  evt_couple_fight_name: '커플 싸움',
  evt_couple_fight_desc: '커플이 줄에서 크게 싸우기 시작합니다. 주변 손님들이 불편해합니다.',
  evt_couple_fight_c1: '처리하기',
  evt_couple_fight_r1: '상황이 정리되었습니다.',

  evt_crying_child_name: '우는 아이',
  evt_crying_child_desc: '아이가 줄에서 울기 시작합니다. 다른 손님들이 불안해합니다.',
  evt_crying_child_c1: '사탕 주기 (50 SP)',
  evt_crying_child_c2: '무시',
  evt_crying_child_r1: '사탕으로 아이가 기분이 좋아졌습니다.',
  evt_crying_child_r2: '울음소리가 계속되어 모두의 인내심이 줄었습니다.',

  evt_blackout_name: '정전',
  evt_blackout_desc: '갑자기 정전이 발생해 모든 것이 어둠에 잠깁니다.',
  evt_blackout_c1: '발전기 가동 (200 SP)',
  evt_blackout_c2: '기다리기',
  evt_blackout_r1: '발전기가 작동했습니다. 영업을 계속합니다.',
  evt_blackout_r2: '모두 어둠 속에서 잠시 기다렸습니다.',

  evt_line_cutter_name: '새치기',
  evt_line_cutter_desc: '누군가 뻔뻔하게 줄 앞으로 끼어듭니다.',
  evt_line_cutter_c1: '경비 호출',
  evt_line_cutter_c2: '무시',
  evt_line_cutter_r1: '경비가 새치기한 사람을 퇴장시켰습니다.',
  evt_line_cutter_r2: '뒤에 있던 손님들이 불만을 표합니다.',

  evt_fake_ghost_name: '가짜 유령 소동',
  evt_fake_ghost_desc: '손님이 유령 코스프레를 하고 다른 손님들을 놀래킵니다. 반응이 좋습니다.',
  evt_fake_ghost_c1: '즐기게 두기',
  evt_fake_ghost_r1: '소동이 으스스한 분위기에 기여했습니다. 평판 상승!',

  evt_lost_item_name: '분실물 신고',
  evt_lost_item_desc: '손님이 입구 근처에서 분실물을 신고합니다.',
  evt_lost_item_c1: '찾아주기 (평판 +5)',
  evt_lost_item_c2: '무시',
  evt_lost_item_r1: '분실물을 찾았습니다! 손님이 감사해합니다.',
  evt_lost_item_r2: '손님이 실망하며 떠났습니다.',

  evt_snack_sold_out_name: '간식 매진',
  evt_snack_sold_out_desc: '간식 카트의 재고가 바닥났습니다. 손님들이 간식을 찾고 있습니다.',
  evt_snack_sold_out_c1: '긴급 보충 (100 SP)',
  evt_snack_sold_out_c2: '다음 입고 대기',
  evt_snack_sold_out_r1: '간식이 다시 채워졌습니다.',
  evt_snack_sold_out_r2: '손님들이 좀 더 기다려야 합니다.',

  evt_sns_selfie_name: 'SNS 인증샷',
  evt_sns_selfie_desc: '손님이 SNS에 올릴 인증샷을 찍으려 합니다.',
  evt_sns_selfie_c1: '확인',
  evt_sns_selfie_r1: '게시물이 온라인 인지도를 높였습니다.',

  evt_hot_weather_name: '폭염',
  evt_hot_weather_desc: '기온이 치솟습니다. 손님들이 더위에 불편해합니다.',
  evt_hot_weather_c1: '무료 음료 제공 (150 SP)',
  evt_hot_weather_c2: '참기',
  evt_hot_weather_r1: '시원한 음료로 모두 기분이 나아졌습니다.',
  evt_hot_weather_r2: '더위가 인내심을 깎고 있습니다.',

  // Tier 2
  evt_tour_bus_name: '단체 관광 버스',
  evt_tour_bus_desc: '관광 버스가 도착했습니다! 대규모 관광객들이 입구로 몰려옵니다.',
  evt_tour_bus_c1: '환영하기',
  evt_tour_bus_r1: '대기열이 흥분한 관광객들로 가득 찼습니다.',

  evt_tv_coverage_name: 'TV 취재 요청',
  evt_tv_coverage_desc: '지역 TV 방송국에서 유령의 집을 취재하고 싶어합니다.',
  evt_tv_coverage_c1: '수락 (위험 있음)',
  evt_tv_coverage_c2: '거절',
  evt_tv_coverage_r1: '방송이 나갔습니다. 결과는 다양합니다...',
  evt_tv_coverage_r2: '정중히 거절했습니다.',

  evt_spy_name: '경쟁업체 스파이',
  evt_spy_desc: '수상하게 메모를 하고 있는 사람을 발견합니다.',
  evt_spy_c1: '체포 (경비 필요)',
  evt_spy_c2: '무시',
  evt_spy_r1: '스파이를 잡았습니다. 귀중한 정보를 회수했습니다.',
  evt_spy_r2: '아이디어 일부가 경쟁사에 유출될 수 있습니다.',

  evt_health_inspection_name: '보건소 점검',
  evt_health_inspection_desc: '보건 점검관이 불시에 방문합니다.',
  evt_health_inspection_c1: '문 열기',
  evt_health_inspection_r1: '점검이 완료되었습니다.',

  evt_halloween_season_name: '할로윈 시즌',
  evt_halloween_season_desc: '할로윈 분위기가 가득합니다! 모두가 공포를 즐길 준비가 되어 있습니다.',
  evt_halloween_season_c1: '축하하기!',
  evt_halloween_season_r1: '할로윈 부스트! 추가 방문객과 SP가 들어옵니다.',

  evt_ghost_strike_name: '유령 파업',
  evt_ghost_strike_desc: '과로한 유령들이 놀래키기를 거부합니다. 더 나은 대우를 요구합니다.',
  evt_ghost_strike_c1: '보너스 지급 (500 SP)',
  evt_ghost_strike_c2: '기다리기',
  evt_ghost_strike_r1: '보너스에 유령들이 만족했습니다. 업무 복귀!',
  evt_ghost_strike_r2: '파업이 한동안 계속됩니다...',

  evt_mystery_visitor_name: '미스터리 평가사',
  evt_mystery_visitor_desc: '유명한 공포 평론가가 변장하고 방문 중입니다. 결과는 평판에 달렸습니다.',
  evt_mystery_visitor_c1: '최선을 다하기',
  evt_mystery_visitor_r1: '평론가가 정체를 밝히고 리뷰를 작성했습니다.',

  evt_maintenance_accident_name: '장비 사고',
  evt_maintenance_accident_desc: '방 하나에서 장비가 고장났습니다!',
  evt_maintenance_accident_c1: '피해 확인',
  evt_maintenance_accident_r1: '방이 손상되었습니다. 수리가 필요합니다.',

  evt_sns_viral_name: 'SNS 바이럴',
  evt_sns_viral_desc: '손님이 올린 유령의 집 영상이 온라인에서 대박 났습니다!',
  evt_sns_viral_c1: '흐름 타기',
  evt_sns_viral_r1: '명성이 급상승합니다! 평판과 SP가 증가했습니다.',

  evt_total_blackout_name: '대정전',
  evt_total_blackout_desc: '전체 지역의 전력이 나갔습니다. 완전한 어둠.',
  evt_total_blackout_c1: '촛불 이벤트 (+평판)',
  evt_total_blackout_c2: '전력 복구 대기',
  evt_total_blackout_r1: '촛불 분위기가 대히트였습니다!',
  evt_total_blackout_r2: '모두 어둠 속에서 기다렸습니다.',

  // Tier 3
  evt_famous_youtuber_name: '유명 스트리머',
  evt_famous_youtuber_desc: '수백만 팔로워를 가진 유명 공포 스트리머가 유령의 집에서 생방송 중입니다!',
  evt_famous_youtuber_c1: 'VIP 대우하기',
  evt_famous_youtuber_r1: '방송이 대성공! 평판 +30, SP +2000.',

  evt_celeb_visit_name: '셀럽 방문',
  evt_celeb_visit_desc: '유명 연예인이 프라이빗 공포 체험을 위해 방문했습니다!',
  evt_celeb_visit_c1: '레드카펫 깔기',
  evt_celeb_visit_r1: '셀럽이 매우 만족했습니다! 엄청난 홍보 효과.',

  evt_franchise_offer_name: '프랜차이즈 제안',
  evt_franchise_offer_desc: '대기업에서 유령의 집 브랜드를 프랜차이즈하고 싶어합니다.',
  evt_franchise_offer_c1: '수락 (10000 SP)',
  evt_franchise_offer_c2: '거절',
  evt_franchise_offer_r1: '계약 체결! 큰 금액이 들어옵니다.',
  evt_franchise_offer_r2: '독립적으로 운영하기를 선택했습니다.',

  evt_intl_contest_name: '국제 공포 대회',
  evt_intl_contest_desc: '유령의 집이 국제 공포 대회에 초청되었습니다!',
  evt_intl_contest_c1: '대회 참가',
  evt_intl_contest_r1: '세계 무대에서 인정받았습니다!',

  evt_documentary_name: '다큐멘터리 촬영',
  evt_documentary_desc: '다큐멘터리 팀이 유령의 집의 이야기를 촬영하고 싶어합니다.',
  evt_documentary_c1: '촬영 허가',
  evt_documentary_r1: '다큐멘터리가 극찬 속에 공개되었습니다!',

  evt_ghost_king_name: '유령왕 등장',
  evt_ghost_king_desc: '전설의 유령이 유령의 집의 명성에 이끌려 나타났습니다.',
  evt_ghost_king_c1: '유령왕 환영',
  evt_ghost_king_r1: '유령왕이 합류했습니다! 사기가 치솟습니다.',

  evt_gov_subsidy_name: '정부 보조금',
  evt_gov_subsidy_desc: '관광청에서 문화 보존 보조금을 수여합니다.',
  evt_gov_subsidy_c1: '보조금 수령',
  evt_gov_subsidy_r1: '보조금 수령: 5000 SP!',

  evt_vip_party_name: 'VIP 파티 요청',
  evt_vip_party_desc: '부유한 후원자가 유령의 집 전체를 프라이빗 파티로 빌리고 싶어합니다.',
  evt_vip_party_c1: '수락 (8000 SP)',
  evt_vip_party_c2: '거절',
  evt_vip_party_r1: 'VIP 파티가 대성공이었습니다!',
  evt_vip_party_r2: '일반 영업을 유지하기로 했습니다.',

  evt_horror_festival_name: '공포 축제',
  evt_horror_festival_desc: '도시에서 공포 축제를 개최하며 유령의 집이 메인 명소입니다!',
  evt_horror_festival_c1: '축제 이끌기',
  evt_horror_festival_r1: '전설적인 축제였습니다! 대규모 보상 획득.',

  evt_legendary_review_name: '전설의 리뷰',
  evt_legendary_review_desc: '세계에서 가장 유명한 공포 평론가가 유령의 집에 극찬 리뷰를 게재합니다.',
  evt_legendary_review_c1: '영광을 누리기',
  evt_legendary_review_r1: '5성 리뷰와 명성이 쏟아집니다!',

  // === Event Defense System ===
  evt_defense_badge: '자동 해결!',
  evt_defense_bonus: '보너스: +{sp} SP',

  // Tier 1 Defense
  evt_rain_defense: '지붕 업그레이드 덕분에 모두 비를 피했습니다. 아무도 떠나지 않습니다!',
  evt_rain_hint: '대비법: 포스터 벽을 Lv.3으로 업그레이드하면 비를 자동 방어합니다.',
  evt_couple_fight_defense: '경비가 나서서 상황을 차분하게 중재했습니다.',
  evt_couple_fight_hint: '대비법: 경비 직원을 고용하면 싸움을 자동 해결합니다.',
  evt_crying_child_defense: '간식 카트에서 사탕을 건넸습니다. 아이가 웃습니다!',
  evt_crying_child_hint: '대비법: 간식 카트를 설치하면 우는 아이를 자동으로 달랩니다.',
  evt_blackout_defense: '비상 발전기가 자동으로 가동됩니다. 중단 없음!',
  evt_blackout_hint: '대비법: 시설 레벨 합계 10 이상이면 비상 전력이 확보됩니다.',
  evt_line_cutter_defense: '경비가 새치기한 사람을 즉시 처리했습니다. 질서 회복!',
  evt_line_cutter_hint: '대비법: 경비 직원을 고용하면 새치기를 자동 처리합니다.',
  evt_fake_ghost_defense: '진짜 NPC 유령이 가짜를 압도합니다. 기대감 상승!',
  evt_fake_ghost_hint: '대비법: 로비에 NPC 유령을 1마리 이상 배치하면 가짜를 압도합니다.',
  evt_lost_item_defense: '직원들이 신속하게 분실물을 찾아 돌려줬습니다!',
  evt_lost_item_hint: '대비법: 직원 3명 이상을 고용하면 분실물을 자동 탐색합니다.',
  evt_snack_sold_out_defense: '예비 재고에서 자동 보충되었습니다. 판매 계속!',
  evt_snack_sold_out_hint: '대비법: 간식 카트를 Lv.2 이상으로 업그레이드하면 자동 보충됩니다.',
  evt_sns_selfie_defense: '포토존이 완벽한 배경을 제공합니다. 멋진 사진이 올라갔습니다!',
  evt_sns_selfie_hint: '대비법: 포토존을 설치하면 자동으로 촬영 기회를 제공합니다.',
  evt_hot_weather_defense: 'TV 모니터 구역에 에어컨이 가동됩니다. 모두 시원하게!',
  evt_hot_weather_hint: '대비법: TV 모니터를 설치하면 냉방 대기 공간을 제공합니다.',

  // Tier 2 Defense
  evt_tour_bus_defense: '자리가 충분합니다! 관광객 전원을 수용했습니다.',
  evt_tour_bus_hint: '대비법: 대기열 수용력을 15 이상으로 확장하면 대규모 단체를 수용합니다.',
  evt_tv_coverage_defense: '높은 평판과 많은 유령 덕분에 방송이 대성공!',
  evt_tv_coverage_hint: '대비법: 평판 50 이상, 유령 5마리 이상이면 방송 성공이 보장됩니다.',
  evt_spy_defense: '경비가 스파이를 현행범으로 잡았습니다! 정보 회수 완료.',
  evt_spy_hint: '대비법: 경비 직원을 고용하면 스파이를 자동 감지합니다.',
  evt_health_inspection_defense: '완벽한 청결! 점검관이 위생 인증서를 수여합니다.',
  evt_health_inspection_hint: '대비법: 청소부를 고용하고 평균 청결도 70 이상을 유지하세요.',
  evt_ghost_strike_defense: '유령들이 충분히 쉬어서 컨디션이 좋습니다. 오늘은 파업 없음!',
  evt_ghost_strike_hint: '대비법: 평균 피로도를 30 이하로 유지하면 파업을 방지합니다.',
  evt_mystery_visitor_defense: '뛰어난 평판 덕분에 극찬 리뷰를 받았습니다!',
  evt_mystery_visitor_hint: '대비법: 평판 60 이상을 유지하면 좋은 평가가 보장됩니다.',
  evt_maintenance_accident_defense: '수리공이 현장에서 바로 수리했습니다. 피해 최소화!',
  evt_maintenance_accident_hint: '대비법: 수리공을 고용하면 장비 피해를 최소화합니다.',
  evt_total_blackout_defense: '수리공이 즉시 전력을 복구했습니다. 촛불 이벤트 보너스!',
  evt_total_blackout_hint: '대비법: 수리공을 고용하고 시설 레벨 합계 15 이상을 달성하세요.',

  // Tier 3 Defense
  evt_vip_party_defense: '의상 대여와 포토존이 파티를 잊을 수 없게 만들었습니다! 일반 영업도 계속됩니다.',
  evt_vip_party_hint: '대비법: 의상 대여소와 포토존을 설치하면 최고의 파티를 열 수 있습니다.',

  // === 유령 거리 ===
  world_title: '건물',
  world_subtitle: '테마별 건물을 선택하세요',
  world_empty_plot: '공사 예정 부지',
  world_build_new: '새 테마 건물을 지을 수 있습니다',
  rename_building: '건물 이름 변경',
  rename_building_desc: '새 건물 이름을 입력하세요.',
  rename: '변경',
  building_renamed: '건물 이름이 변경되었습니다!',

  // === 건물 공사 팝업 ===
  construction_title: '새 건물 공사',
  construction_subtitle: '새로운 유령의 집을 지어 운영해보세요!',
  construction_name_label: '건물 이름',
  construction_name_placeholder: '예: 심야 저택',
  construction_theme_label: '건물 테마',
  construction_start: '공사하기',
  world_status_build: '공사하기',
  world_status_open: '운영 중',
  world_status_ready: '준비 중',
  theme_haunted_house: '유령의 집',
  theme_haunted_house_desc: '클래식한 귀여운 유령 체험관',
  theme_abandoned_hospital: '폐병원',
  theme_abandoned_hospital_desc: '의료 공포와 실험실 분위기',
  theme_school_back_mountain: '학교 뒷산',
  theme_school_back_mountain_desc: '학교 괴담과 산길 공포 분위기',
  theme_cursed_circus: '저주받은 서커스',
  theme_cursed_circus_desc: '저주받은 서커스 텐트의 기괴한 공포',
  theme_ancient_temple: '고대 사원',
  theme_ancient_temple_desc: '고대 사원의 신비롭고 섬뜩한 저주',
  theme_pirate_ship: '해적선',
  theme_pirate_ship_desc: '저주받은 해적선의 바다 공포',
  theme_abandoned_mine: '버려진 광산',
  theme_abandoned_mine_desc: '버려진 광산의 깊고 어두운 공포',
  theme_gothic_castle: '고딕 성',
  theme_gothic_castle_desc: '고딕 성의 우아하고 섬뜩한 귀족 공포',
  theme_underground_bunker: '지하 벙커',
  theme_underground_bunker_desc: '지하 벙커의 실험과 음모 공포',
  theme_cursed_forest: '저주받은 숲',
  theme_cursed_forest_desc: '저주받은 숲의 자연령과 원시 공포',
};

export default ko;
